<template lang="pug">
		Popup(v-if="visible", :popupVisible="visible", classes="tracker-dark", :width="580", :height="$auth.hasProAudio() ? 420 : 140", :closeOnOutsideClick="true", @hiding="v => $emit('hiding', v)")
			.flex-col.space
				AudioTrackInfoPanelPostEffects(:headerCaption="headerCaption", mode="selector", :audioContext="audioContext", :tracker="tracker", :postEffects="postEffects")
					template(v-slot:post-effects-left="data")
						slot(name="post-effects-left", v-bind="data", :postEffects="postEffects")
				AudioTrackInfoPanelPostEffects.flex-1(v-if="$auth.hasProAudio() && postEffects.plugins.length",
					mode="plugins-list", :audioContext="audioContext", :tracker="tracker", :postEffects="postEffects")
			template(slot="actions-left")
				slot(name="actions-left")
				DxButton(v-if="$auth.hasProAudio()", :text="$tCaption('Reset', '@actions')", @click="postEffects.plugins = []", icon="fas fa-refresh")
				DxButton(:text="$tCaption('Save', '@actions')", @click="$eventsBus.$emit('tracker--save-current-plugins-bank')", type="default")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Close', '@actions')", @click="$emit('update:visible', false)")
				slot(name="actions-right")
</template>


<script>
	import Popup from 'app-core/Popup.vue';
	import AudioTrackInfoPanelPostEffects from './AudioTrackInfoPanelPostEffects.vue';
	import DxButton from 'devextreme-vue/button';

	export default {
		translationCategory: 'audioTracker.AudioTracker',
		name: 'audio-tracker--post-effects-popup',
		components: { Popup, AudioTrackInfoPanelPostEffects, DxButton },
		props: ['postEffects', 'tracker', 'audioContext', 'visible', 'headerCaption'],
		data() {
			return {
			};
		},
		watch: {
			
		},
		computed: {
		},
		mounted() {
			if (__DEBUG__)
				window.postEffectsPopup = this;
		},
		destroyed() {

		},
		methods: {
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";
	.audio-tracker--post-effects-popup {

	}
</style>
